/**
 * Sort products based on discount value and special criteria
 * Order: Chocolate Bliss first, then 70% OFF, 20% OFF, 15% OFF, Best Seller, No Discount
 *
 * Performance optimizations:
 * - Pre-compute all data attributes once (O(n) instead of O(n log n))
 * - Cache string operations outside comparator
 * - Use DocumentFragment to minimize reflows
 */
function sortProducts(container) {
  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) {
    return;
  }

  const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

  // Pre-compute all sort data once (single DOM pass)
  const slideData = slides.map(slide => {
    const card = slide.querySelector('.product-card');
    if (!card) {
      return {
        slide,
        title: '',
        discount: 0,
        isBestSeller: false,
        isChocolateBliss: false
      };
    }

    const title = (card.getAttribute('data-product-title') || '').toLowerCase();

    return {
      slide,
      title,
      discount: parseFloat(card.getAttribute('data-discount-value')) || 0,
      isBestSeller: card.getAttribute('data-is-best-seller') === 'true',
      isChocolateBliss: title.includes('chocolate bliss')
    };
  });

  // Sort using pre-computed data (no DOM access in comparator)
  slideData.sort((a, b) => {
    // Priority 1: Chocolate Bliss always first
    if (a.isChocolateBliss && !b.isChocolateBliss) return -1;
    if (!a.isChocolateBliss && b.isChocolateBliss) return 1;

    // Priority 2: Sort by discount percentage (highest first)
    if (a.discount > 0 || b.discount > 0) {
      if (a.discount !== b.discount) {
        return b.discount - a.discount; // Higher discount first
      }
    }

    // Priority 3: Best Seller products
    if (a.isBestSeller && !b.isBestSeller && a.discount === 0 && b.discount === 0) return -1;
    if (!a.isBestSeller && b.isBestSeller && a.discount === 0 && b.discount === 0) return 1;

    // Priority 4: Products with no discount or best seller badge go last
    if (a.discount === 0 && !a.isBestSeller && (b.discount > 0 || b.isBestSeller)) return 1;
    if (b.discount === 0 && !b.isBestSeller && (a.discount > 0 || a.isBestSeller)) return -1;

    return 0;
  });

  // Use DocumentFragment to minimize reflows (single DOM update)
  const fragment = document.createDocumentFragment();
  slideData.forEach(item => fragment.appendChild(item.slide));
  wrapper.appendChild(fragment);
}

document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(
    ".product-card-carousel .swiper-container"
  );
  swiperContainers.forEach((container) => {
    const sectionId = container.id.replace("swiper_", "");
    const enableSorting = container.getAttribute('data-enable-sorting') === 'true';

    // Sort products if enabled
    if (enableSorting) {
      sortProducts(container);
    }

    const swiper = new Swiper(container, {
      observer: true,
      simulateTouch: true,
      slidesPerView: 1.5,
      spaceBetween: 20,
      navigation: {
        nextEl: `#next_${sectionId}`,
        prevEl: `#prev_${sectionId}`,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },
      breakpoints: {
        425: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1140: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });

    // Hide navigation buttons if not needed
    const nextButton = document.querySelector(`#next_${sectionId}`);
    const prevButton = document.querySelector(`#prev_${sectionId}`);
    const totalSlides = container.querySelectorAll(".swiper-slide").length;

    function updateNavigationVisibility() {
      const slidesPerView = swiper.params.slidesPerView;
      if (totalSlides <= slidesPerView) {
        nextButton.style.display = "none";
        prevButton.style.display = "none";
      } else {
        nextButton.style.display = "";
        prevButton.style.display = "";
      }
    }

    swiper.on("init", updateNavigationVisibility);
    swiper.on("resize", updateNavigationVisibility);
    swiper.init();

     // Add event listeners inside the loop
      nextButton.addEventListener("click", function () {
        swiper.slideNext();
      });
      prevButton.addEventListener("click", function () {
        swiper.slidePrev();
      });
  });

  // // Add event listeners inside the loop
  // nextButton.addEventListener("click", function () {
  //   swiper.slideNext();
  // });
  // prevButton.addEventListener("click", function () {
  //   swiper.slidePrev();
  // });
});
